import { render, staticRenderFns } from "./reports-legend-pie.vue?vue&type=template&id=f0487080&scoped=true"
import script from "./reports-legend-pie.vue?vue&type=script&lang=js"
export * from "./reports-legend-pie.vue?vue&type=script&lang=js"
import style0 from "./reports-legend-pie.vue?vue&type=style&index=0&id=f0487080&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0487080",
  null
  
)

export default component.exports